import { type FC } from "react";
import { useSearchParams } from "react-router-dom";

import { AcceptInvitationFlow } from "./AcceptInvitationFlow";

const AcceptInvitationPage: FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") ?? "";
  const inviterName = searchParams.get("inviter")
    ? decodeURIComponent(searchParams.get("inviter")!)
    : "Someone";
  const decedentName = searchParams.get("person")
    ? decodeURIComponent(searchParams.get("person")!)
    : "a loved one";

  return (
    <AcceptInvitationFlow inviterName={inviterName} decedentName={decedentName} token={token} />
  );
};

export default AcceptInvitationPage;
